<template>
  <div style="position: relative;">
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :option="option"
      :page="page"
      :loading="loading"
      :before-open="beforeOpen"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
      @submit-add="submitAdd"
      @submit-edit="submitEdit"
    >
      <template
        slot="menuLeft"
        slot-scope="{row}"
      >
        <my-tooltip :tooltip="$t('_components.btns.view')">
          <feather-icon
            icon="SearchIcon"
            class="text-warning cursor-pointer"
            size="20"
            @click="handleFormOpen('view',row)"
          />
        </my-tooltip>
      </template>

      <!-- 自定义列 -->
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span v-if="props.column.field === 'readStatusName'">
          <template v-if="props.row.readStatus === 1">
            <div
              class="status-tag bg-gradient-success"
            />
            {{ props.row.readStatusName }}
          </template>
          <template v-else>
            <div
              class="status-tag bg-gradient-warning"
            />
            {{ props.row.readStatusName }}
          </template>
        </span>
      </template>
    </gtable-crud>

    <!-- 表单 -->
    <!-- <c-drawer
      v-model="formVisible"
      :before-close="handleBeforeClose"
    >
      <my-form
        ref="formRef"
        :data="form"
        :loading="formLoading"
        :option="option"
        :footer-visible="false"
        width="auto"
      />
    </c-drawer> -->

    <b-modal
      id="modal-center"
      v-model="formVisible"
      centered
      :title="form.title"
      ok-only
      :ok-title="i18n('read')"
      :hide-footer="form.readStatus==1"
      @ok="markNoticeRead"
    >
      <b-card-text>
        <div
          class="notice-content"
        >
          <div
            v-if="form.content"
            v-html="form.content"
          />
          <a-empty
            v-else
            class="media-list__empty"
            description="Not content"
          />
        </div>
        <element-component
          v-if="form.fileId"
          v-model="form.file"
          :disabled="true"
          :option="{ type: 'upload' }"
        />
        <div class="notice-footer">
          <p> {{ form.releaseTime }}</p>
        </div>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import MyTooltip from '@/components/myTooltip.vue';
// import CDrawer from '@/components/drawer.vue';
import todoAPi from '@/api/todo/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BModal,
} from 'bootstrap-vue'
// import MyForm from '@/components/myForm/index.vue';

export default {
  name: 'MyComponent',
  components: {
    // BBadge,
    // BButton,
    // CDrawer,
    MyTooltip,
    // MyForm,
    BModal,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      data: [],
      loading: false,
      drawerTitle: '',
      formVisible: false,
      form: {},
      formLoading: false,
    };
  },
  computed: {
    option() {
      const columns = [ // 列的其他配置可参考vue-good-table
        {
          label: this.i18n('title'),
          field: 'title',
        },
        {
          label: this.i18n('releaseUser'),
          field: 'createUserName',
        },
        {
          label: this.i18n('readStatus'),
          field: 'readStatus',
          dictField: 'readStatusName',
          html: true,
        },
        {
          label: this.i18n('releaseTime'),
          field: 'releaseTime',
        },
      ]
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
      return option
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await todoAPi.noticeList(page.currentPage, page.pageSize, Object.assign(params, this.query, { type: 2 }))
      const { data } = res.data;
      this.page.total = data.total;
      this.data = data.records;
      this.loading = false
    },
    // i18n
    i18n(param) {
      return this.$t(`_todo.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      this.query = e
      this.page.currentPage = 1;
      await this.onLoad(this.page, e);
      done();
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page);
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    // 点击下载按钮
    rowDel(e) {
      todoAPi.noticeRemove(e.id).then(() => {
        this.onLoad(this.page);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.danger'),
            variant: 'danger',
          },
        })
      })
      // 返回当前行数据
      console.log(e, 'rowDel')
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    beforeOpen(done, type) {
      const formatDic = {
        add: 'Add',
        edit: 'Edit',
        view: 'View',
        upload: 'Upload',
      }
      this.drawerTitle = formatDic[type]
      done()
    },
    submitAdd(done, form) {
      todoAPi.noticeAdd(form).then(() => {
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: this.$t('system.user.tip.success'), // "操作成功!"
        });
        done();
      }).catch(() => {
        done();
      })
    },
    submitEdit(done, form) {
      todoAPi.noticeUpdate(form).then(() => {
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: this.$t('system.user.tip.success'), // "操作成功!"
        });
        done();
      }).catch(() => {
        done();
      })
    },
    handleBeforeClose(done) {
      done()
      this.onLoad(this.page)
    },
    handleDrawerClose() {
      this.formVisible = false
      this.onLoad(this.page);
    },
    handleFormOpen(key, row = {}) {
      this.form = row
      this.formVisible = true
    },
    markNoticeRead() {
      todoAPi.noticeMarkRead({ ids: this.form.noticeId }).then(res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.onLoad(this.page)
      })
    },
  },
};
</script>
